export const ENGLISH_IQ_LANDING_IMG_SLUG = 'english-iq';
